import fetch from "auth/FetchInterceptor";

export const DistrictService = {};

DistrictService.get = async ({
  page,
  pageSize,
  sort,
  searchText,
  state = null,
}) => {
  let apiUrl = "/v1/district?page=" + page + "&per_page=" + pageSize;
  if (sort === "ascend") apiUrl += "&order_by=%2Dname";
  else if (sort === "descend") apiUrl += "&order_by=%2Bname";
  if (searchText) apiUrl += "&name=" + searchText;
  if (state) {
    apiUrl += "&state=" + state;
  }
  return fetch({
    url: apiUrl,
    method: "get",
  });
};

DistrictService.getById = async (id) => {
  const apiUrl = `/v1/district/${id}`;
  return fetch({
    url: apiUrl,
    method: "get",
  });
};

DistrictService.createDistrict = async (data) => {
  const apiUrl = `/v1/district`;
  return fetch({
    url: apiUrl,
    method: "post",
    data: data,
  });
};

DistrictService.updateDistrict = async (data) => {
  const apiUrl = `/v1/district/${data.id}`;
  return fetch({
    url: apiUrl,
    method: "put",
    data: data,
  });
};

DistrictService.deleteDistrict = async (id, confirm = false) => {
  let apiUrl = `/v1/district/${id}`;
  if (confirm) apiUrl = `/v1/district/${id}?confirmed`;
  return fetch({
    url: apiUrl,
    method: "delete",
  });
};

export default DistrictService;
